import { IAction } from '../sagas';
import { ADD_COMMENT_SUCCESS, UPDATE_COMMENT_SUCCESS, REMOVE_COMMENT_SUCCESS, REQUEST_COMMENT_SUCCESS, REQUEST_COMMENTS_SUCCESS } from '../handlers.actions';
import { IComment } from '../models/comment';

const initCommentsStore: any = () => ([]);

/** COMMENT REDUCER */
export const commentReducer = (state = initCommentsStore(), action: IAction) => {
    switch (action.type) {
         case ADD_COMMENT_SUCCESS:
              return [
                   ...state.slice(0, action.payload),
                   action.payload.comment,
                   ...state.slice(action.payload)
              ];

         case UPDATE_COMMENT_SUCCESS:               
              return state.map((comment: any) => {
                   if (comment._id === action.payload._id) {
                        return action.payload;
                   }
                   return comment;
              });

         case REMOVE_COMMENT_SUCCESS:               
              return state.filter((comment: any) => comment._id !== action.payload.commentId); 

         case REQUEST_COMMENT_SUCCESS:
              return [
                   ...state.slice(0, action.payload),
                   action.payload,
                   ...state.slice(action.payload)
              ];

         case REQUEST_COMMENTS_SUCCESS:
              const merged = [...state, ...action.payload];
              const set = new Set();
              const unionArray = merged.filter((comment:IComment) => {
                   if(!set.has(comment._id)){
                        set.add(comment._id);
                        return true;
                   }
                   return false;
              }, set);              
              return [ ...unionArray ]; 

         default:
              return state;
    }
};
